/*
 * Copyright (c) 2022. Haodong JU
 */

import hillo from 'hillo'

// export const baseUrl = 'http://' + GlobalConfig.Base + ':8018/'
export const baseUrl = 'http://resource.ngrok.aaden.io/'
const name = 'dishResourceConsumption/'

export async function getDishConsumptionList () {
  return (await hillo.jsonPost(baseUrl + name + 'getList', {})).data
}

export async function setDishConsumption (dishId, dishType, dishResourceId, resourceUnitId, consumption) {
  return (await hillo.jsonPost(baseUrl + name + 'set', {
    dishId,
    dishType,
    dishResourceId,
    resourceUnitId,
    consumption,
  })).data
}

export async function deleteDishConsumption (dishId, dishType, dishResourceId, resourceUnitId) {
  return (await hillo.jsonPost(baseUrl + name + 'delete', {
    dishId,
    dishType,
    dishResourceId,
    resourceUnitId,
  })).data
}

